export enum FileDropClass {
  DragOver = 'pcs-dragover',
  DropNotAllowed = 'pcs-drop-error'
}
